import { Popup, Space, Switch } from 'antd-mobile'
import { SetOutline } from 'antd-mobile-icons'
import React, { useLayoutEffect, useState } from 'react'

function SettingPopup() {

    const [active, setActive] = useState(false);

    const [enableDarkMode, setEnableDarkMode] = useState(true)
    useLayoutEffect(() => {
        document.documentElement.setAttribute(
            'data-prefers-color-scheme',
            enableDarkMode ? 'dark' : 'light'
        )
        console.log("LayoutEffect");

    }, [enableDarkMode])

    return (
        <div>
            <SetOutline fontSize={25} onClick={() => setActive(true)} />
            <Popup
                visible={active}
                onMaskClick={() => { setActive(false) }}
                onClose={() => { setActive(false) }}
            // bodyStyle={{ height: '40vh' }}
            >
                <div style={{
                    padding: "20px"
                }}>
                    <Space align='center'>
                        <div>Dark Mode</div>
                        <Switch
                            checked={enableDarkMode}
                            onChange={v => {
                                setEnableDarkMode(v)
                            }}
                        />
                    </Space>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Reiciendis sequi voluptatem culpa molestias laborum nesciunt earum, deserunt illo! Ad mollitia dolore aliquam ipsa in hic qui illo doloremque eligendi molestias.
                </div>
            </Popup>
        </div>
    )
}

export default SettingPopup